import Vue from 'vue';
import Vuex from 'vuex';

import { Translations } from '../language';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        translations: Translations,
        errorMessage: '',
        showError: false
    },
    getters: {
        translations: state => {
            return state.translations;
        }
    },
    mutations: {
        setTranslations: (state, payload) => {
            state.translations = payload;
        },
        setErrorMessage: (state, payload) => {
            switch (payload) {
                case 'TOKEN_FAILURE':
                    payload = state.translations.tokenFailure;
                    break;
                case 'UNKNOWN':
                    payload = state.translations.tokenFailure;
                    break;
                default:
            }
            state.errorMessage = payload;
        },
        setErrorState: (state, payload) => {
            state.showError = payload;
        }
    },
    actions: {
        setTranslations: ({ commit }, payload) => {
            commit('setTranslations', payload);
        },
        setErrorMessage: ({ commit }, payload) => {
            commit('setErrorMessage', payload);
        },
        setErrorState: ({ commit }, payload) => {
            commit('setErrorState', payload);
        }
    }
});
